import { FC } from "react";
import {
  Button as ButtonTyp,
  ProductAttributes,
} from "../../../types/strapiRes";
import { PriceWithDiscount } from "../../PriceWithDiscount/PriceWithDiscount";

import "./SlideCard.css";
import Button from "../../Buttons";
import { Link } from "react-router-dom";

interface Props {
  id: number;
  data: ProductAttributes;
  productsDiscountButton: ButtonTyp;
}

const SlideCard: FC<Props> = ({ id, data, productsDiscountButton }) => {
  const categoryData = (data as any).categories?.data || (data as any).category?.data;
  const categorySlug = categoryData?.[0]?.attributes?.slug || "all";
  const currencyName = data.currency?.data?.attributes?.name || "грн";
  const firstImageData = data.images?.data?.[0]?.attributes;
  const imageUrl = firstImageData?.url
    ? process.env.REACT_APP_API_URL + firstImageData.url
    : "/placeholder.png";

  return (
    <div className="container slide-card">
      <div className="slide-card__info">
        <div>
          <h2>{data.name}</h2>
          <p>{data.desc_short}</p>
        </div>

        {/* Десктоп: ціна + кнопка як раніше */}
        <div className="slide-card__buy-btn">
          <PriceWithDiscount
            currency={currencyName}
            discountPrice={data.discount_price as string}
            price={data.price}
          />
          <Button
            href={`/categories/${categorySlug}/${id}`}
            btnType="link"
            buttonProps={productsDiscountButton}
          />
        </div>

        {/* Мобайл: ціна зліва + іконка кошика справа */}
        <div className="slide-card__footer">
          <PriceWithDiscount
            currency={currencyName}
            discountPrice={data.discount_price as string}
            price={data.price}
          />
          <Link
            to={`/categories/${categorySlug}/${id}`}
            className="slide-card__cart-btn"
          >
            <img src="/static/images/shopping-cart.svg" alt="Cart" />
          </Link>
        </div>
      </div>

      <div>
        <img
          className="slide-card__img"
          src={imageUrl}
          alt={firstImageData?.alternativeText || data.name}
        />
      </div>
    </div>
  );
};

export default SlideCard;